import { roadB2C } from "../../utils/ROADS/roadB2C";
import RoadMapGeneric from "../../components/Roadmaps/RoadMapGeneric";

const RoadMapB2C = (props) => <RoadMapGeneric {...props} roadData={roadB2C} />;
export default RoadMapB2C;